// src/pages/DoctorAvailabilityPage.jsx
// Route: /doctors/:id/availability
//
// Navigator/admin editing a doctor's availability on their behalf. :id here
// is doctors.id — the same id doctorAPI.list()/get() already return and
// DoctorsPage.js already navigates with — not the navigators.id a doctor's
// own JWT resolves to (see DoctorMyAvailabilityPage.jsx's note on why those
// are two different ids for the same person).

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { doctorAPI } from '../services/api';
import DoctorAvailabilityEditor from '../components/DoctorAvailabilityEditor';

export default function DoctorAvailabilityPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    doctorAPI.get(id)
      .then(r => setDoctor(r.data))
      .catch(() => navigate('/doctors'))
      .finally(() => setLoading(false));
  }, [id, navigate]);

  if (loading) return (
    <AppShell breadcrumbs={[{ label: 'Doctors', to: '/doctors' }, { label: 'Loading…' }]}>
      <div className="loading-state"><div className="spinner" />Loading doctor…</div>
    </AppShell>
  );

  const name = doctor ? `${doctor.firstName} ${doctor.lastName}` : 'Doctor';

  return (
    <AppShell breadcrumbs={[{ label: 'Doctors', to: '/doctors' }, { label: name }, { label: 'Availability' }]}>
      <span className="back-link fade-in-up" onClick={() => navigate('/doctors')}>
        ← Back to Doctors
      </span>
      <DoctorAvailabilityEditor mode="staff" doctorId={id} eyebrow="Scheduling" title={`${name}'s availability`}
        subtitle={`Patients see these hours immediately when booking. ${name.startsWith('Dr.') ? name : `Dr. ${name}`} can also edit them from their own portal.`} />
    </AppShell>
  );
}
